import React, { useState, useEffect } from 'react';
interface User {
    id: string;
    name: string;
    productionIds: number[];
    registryId: string

}
interface ProductionReceiptProps {
    user: any;
    // user: User;
}
const ImageView: React.FC<ProductionReceiptProps> = ({ user }) => {
    console.log("user loadeddddddd", user);
    return (

        <>
            {user.isccEuCertificate && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                    minHeight: '500px'
                }}>
                    <img
                        src="/logo2.jpg"
                        alt="Certificate"
                        style={{
                            width: '60vw',
                            height: 'auto',
                            maxWidth: '400px',
                            maxHeight: '300px',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            )}
            {user.riverNearby && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                    minHeight: '500px'
                }}>
                    <img
                        src="/logo.png"
                        alt="River Nearby"
                        style={{
                            width: '60vw',
                            height: 'auto',
                            maxWidth: '400px',
                            maxHeight: '300px',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            )}
        </>

    );
};
export default ImageView;